exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card.card-api-request-component .card-header[data-v-17a737eb]{padding:1rem;padding-bottom:0}.card.card-api-request-component .b-table[data-v-17a737eb]{min-height:270px;margin:0}.card.card-api-request-component .b-table[data-v-17a737eb] .top.level{margin:0}", ""]);

// exports
